import type ISchoolPeriodUserRepository from '@/core/domain/school/user/ISchoolPeriodUserRepository.ts'

export class FetchSchoolPeriodUserByIdentifierUseCase {
  private readonly schoolPeriodUserRepository: ISchoolPeriodUserRepository

  constructor(schoolPeriodUserRepository: ISchoolPeriodUserRepository) {
    this.schoolPeriodUserRepository = schoolPeriodUserRepository
  }

  async execute(schoolId: number, periodId: number, identifier: string) {
    return await this.schoolPeriodUserRepository.fetchSchoolPeriodUserByIdentifier(
      schoolId,
      periodId,
      identifier
    )
  }
}
